/**
 *  Languages and questions
 */
export const languages = [
    {
        language: 'Connection',
        questions: [
            {
                number: 1,
                answer: `Shows they care about me as a person by asking how I'm doing`,
            },
            {
                number: 2,
                answer: 'Make effort to make a personal connection with me'
            },
            {
                number: 3,
                answer: 'Is willing to let others get to know him/her beyond just work'
            },
            {
                number: 4,
                answer: 'Has a connecting and warm style of communicating'
            },
            {
                number: 5,
                answer: 'Builds a personal relationship with me as well as a working one'
            },
            {
                number: 6,
                answer: 'Appropriately shares their life outside of work to build a stronger relationship at work'
            },
            {
                number: 7,
                answer: `Shows interest in me as a person not just a cog in a machine`
            },
            {
                number: 8,
                answer: 'Engages in conversations about our hobbies and interests outside of work'
            },
            {
                number: 9,
                answer: 'Understands that a good relationship with him/her improves my engagement at work'
            },
            {
                number: 10,
                answer: `Communicates in a way that's warm and friendly`
            },
            {
                number: 11,
                answer: 'Shows genuine interest in how I experience my work, not just how I perform'
            },
            {
                number: 12,
                answer: `Asks "How can I help?" when they know I'm struggling personally`
            }
        ]
    },
    {
        language: 'Mentoring',
        questions: [
            {
                number: 1,
                answer: 'Takes time to provide coaching and guidance on my work '
            },
            {
                number: 2,
                answer: 'Introduces me to new training resources'
            },
            {
                number: 3,
                answer: 'Offers to invest in my professional development'
            },
            {
                number: 4,
                answer: `Invites me to important meetings I'm not normally invited to, so I can learn new things`
            },
            {
                number: 5,
                answer: `Shares valuable lessons they learned the hard way, so I don't have to`
            },
            {
                number: 6,
                answer: 'Takes time to debrief a project or initiative to help me learn how to improve'
            },
            {
                number: 7,
                answer: `Let's me shadow him/ her for important meetings so I can grow`
            },
            {
                number: 8,
                answer: 'Gives me practical guidance on the best way to achieve the goal we have set'
            },
            {
                number: 9,
                answer: 'Shares his/her costly mistakes as a way to help me avoid making the same ones'
            },
            {
                number: 10,
                answer: 'Helps me reframe my mistakes or failures into learning experiences for my growth'
            },
            {
                number: 11,
                answer: 'Shows me exactly how to anticipate problems with my work before they happen'
            },
            {
                number: 12,
                answer: 'Initiates conversations about how I can get to the next level of my growth or career'
            }
        ]
    },
    {
        language: 'Proximity',
        questions: [
            {
                number: 1,
                answer: 'Is easily available to meet in person or voice-to-voice when I need that'
            },
            {
                number: 2,
                answer: 'Is highly responsive to me if I need him/her and knows what’s going on in my work'
            },
            {
                number: 3,
                answer: 'Has good line of sight on the unique dynamics of my role'
            },
            {
                number: 4,
                answer: 'Makes a point of being in our workplace, physically or virtually, when I am'
            },
            {
                number: 5,
                answer: 'Is present physically or virtually for the most important meetings'
            },
            {
                number: 6,
                answer: 'Has his/her finger on the pulse of the organization and is in the know'
            },
            {
                number: 7,
                answer: 'Is present in the organization so they can understand my contribution and output'
            },
            {
                number: 8,
                answer: 'Has a physical or virtual open door policy that allows access to him/ her'
            },
            {
                number: 9,
                answer: `Makes decisions clearly informed by what's happening in my work`
            },
            {
                number: 10,
                answer: `Has close proximity to the organization and clear line of sight on what's happening`
            },
            {
                number: 11,
                answer: 'Is close enough to understand the unique challenges I face in my role'
            },
            {
                number: 12,
                answer: 'Provides regular insight into their work to better inform my work'
            }
        ]
    },
    {
        language: 'Recognition',
        questions: [
            {
                number: 1,
                answer: 'Publicly recognizes my performance in front of peers'
            },
            {
                number: 2,
                answer: `Says or writes "you did a great job" when I've performed well`
            },
            {
                number: 3,
                answer: 'Tells me verbally or in writing when he/she appreciates my work'
            },
            {
                number: 4,
                answer: 'Recognizes me verbally when I excel in my achievement'
            },
            {
                number: 5,
                answer: 'Tells me specifically what she/he appreciates about my contribution'
            },
            {
                number: 6,
                answer: `Notices when I've gone above and beyond and thanks me`
            },
            {
                number: 7,
                answer: 'Acknowledges my unique contribution verbally and publicly'
            },
            {
                number: 8,
                answer: `Easily expresses gratitude for excellent work I've done`
            },
            {
                number: 9,
                answer: 'Gives genuine and specific recognition for my achievements'
            },
            {
                number: 10,
                answer: 'Shares authentic appreciation when I put in extra work'
            },
            {
                number: 11,
                answer: 'Shows enthusiastic encouragement for goals I helped us achieve'
            },
            {
                number: 12,
                answer: 'Says or writes "Thank you for all the time you put into this, I know it was a lot."'
            }
        ]
    },
    {
        language: 'Purpose',
        questions: [
            {
                number: 1,
                answer: 'Demonstrates a commitment to a cause greater than personal profit'
            },
            {
                number: 2,
                answer: 'Articulates a clear higher purpose that goes beyond making money'
            },
            {
                number: 3,
                answer: 'Wants to make a positive impact on people or the world'
            },
            {
                number: 4,
                answer: 'Reminds me how my day-to-day work connects to our larger mission'
            },
            {
                number: 5,
                answer: 'Is motivated by a meaningful purpose in addition to performance'
            },
            {
                number: 6,
                answer: 'Articulates an inspiring vision for how our work can make a positive impact'
            },
            {
                number: 7,
                answer: 'Shows an active interest in understanding my sense of higher purpose'
            },
            {
                number: 8,
                answer: 'Is mission driven and can inspire others to the cause'
            },
            {
                number: 9,
                answer: 'Wants to do work that contributes to the common good'
            },
            {
                number: 10,
                answer: 'Is committed to creating a meaningful difference for people and communities '
            },
            {
                number: 11,
                answer: 'Cares as much about making a meaningful impact as a job well done'
            },
            {
                number: 12,
                answer: 'Invests in helping me find connection to my higher purpose'
            }
        ]
    }
];
/**
 *  Quiz Pairings
 */
export const pairings = [
    {
        number: 1,
        statement_1: languages[0].questions[0].answer,
        statement_2: languages[1].questions[0].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[1].language
    },
    {
        number: 2,
        statement_1: languages[0].questions[1].answer,
        statement_2: languages[1].questions[1].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[1].language
    },
    {
        number: 3,
        statement_1: languages[0].questions[2].answer,
        statement_2: languages[1].questions[2].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[1].language
    },
    {
        number: 4,
        statement_1: languages[0].questions[3].answer,
        statement_2: languages[2].questions[0].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[2].language
    },
    {
        number: 5,
        statement_1: languages[0].questions[4].answer,
        statement_2: languages[2].questions[1].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[2].language
    },
    {
        number: 6,
        statement_1: languages[0].questions[5].answer,
        statement_2: languages[2].questions[2].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[2].language
    },
    {
        number: 7,
        statement_1: languages[0].questions[6].answer,
        statement_2: languages[3].questions[0].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[3].language
    },
    {
        number: 8,
        statement_1: languages[0].questions[7].answer,
        statement_2: languages[3].questions[1].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[3].language
    },
    {
        number: 9,
        statement_1: languages[0].questions[8].answer,
        statement_2: languages[3].questions[2].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[3].language
    },
    {
        number: 10,
        statement_1: languages[0].questions[9].answer,
        statement_2: languages[4].questions[0].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[4].language
    },
    {
        number: 11,
        statement_1: languages[0].questions[10].answer,
        statement_2: languages[4].questions[1].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[4].language
    },
    {
        number: 12,
        statement_1: languages[0].questions[11].answer,
        statement_2: languages[4].questions[2].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[0].language,
        statement_2_language: languages[4].language
    },
    {
        number: 13,
        statement_1: languages[1].questions[3].answer,
        statement_2: languages[2].questions[3].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[2].language
    },
    {
        number: 14,
        statement_1: languages[1].questions[4].answer,
        statement_2: languages[2].questions[4].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[2].language
    },
    {
        number: 15,
        statement_1: languages[1].questions[5].answer,
        statement_2: languages[2].questions[5].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[2].language
    },
    {
        number: 16,
        statement_1: languages[1].questions[6].answer,
        statement_2: languages[3].questions[3].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[3].language
    },
    {
        number: 17,
        statement_1: languages[1].questions[7].answer,
        statement_2: languages[3].questions[4].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[3].language
    },
    {
        number: 18,
        statement_1: languages[1].questions[8].answer,
        statement_2: languages[3].questions[5].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[3].language
    },
    {
        number: 19,
        statement_1: languages[1].questions[9].answer,
        statement_2: languages[4].questions[3].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[4].language
    },
    {
        number: 20,
        statement_1: languages[1].questions[10].answer,
        statement_2: languages[4].questions[4].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[4].language
    },
    {
        number: 21,
        statement_1: languages[1].questions[11].answer,
        statement_2: languages[4].questions[5].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[1].language,
        statement_2_language: languages[4].language
    },
    {
        number: 22,
        statement_1: languages[2].questions[6].answer,
        statement_2: languages[3].questions[6].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[2].language,
        statement_2_language: languages[3].language
    },
    {
        number: 23,
        statement_1: languages[2].questions[7].answer,
        statement_2: languages[3].questions[7].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[2].language,
        statement_2_language: languages[3].language
    },
    {
        number: 24,
        statement_1: languages[2].questions[8].answer,
        statement_2: languages[3].questions[8].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[2].language,
        statement_2_language: languages[3].language
    },
    {
        number: 25,
        statement_1: languages[3].questions[9].answer,
        statement_2: languages[4].questions[6].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[3].language,
        statement_2_language: languages[4].language
    },
    {
        number: 26,
        statement_1: languages[3].questions[10].answer,
        statement_2: languages[4].questions[7].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[3].language,
        statement_2_language: languages[4].language
    },
    {
        number: 27,
        statement_1: languages[3].questions[11].answer,
        statement_2: languages[4].questions[8].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[3].language,
        statement_2_language: languages[4].language
    },
    {
        number: 28,
        statement_1: languages[4].questions[9].answer,
        statement_2: languages[2].questions[9].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[4].language,
        statement_2_language: languages[2].language
    },
    {
        number: 29,
        statement_1: languages[4].questions[10].answer,
        statement_2: languages[2].questions[10].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[4].language,
        statement_2_language: languages[2].language
    },
    {
        number: 30,
        statement_1: languages[4].questions[11].answer,
        statement_2: languages[2].questions[11].answer,
        statement_1_value: "1",
        statement_2_value: "2",
        selection: null,
        statement_1_language: languages[4].language,
        statement_2_language: languages[2].language
    }
];
